/* global */ //variable Not defined
/* exported */ //Variable Defined but never used
jQuery(document).ready(function($){
	
	//********************************
    //COOKIE CONSENT MODAL FUNCTIONS
	//********************************
	if($('#wpk-cookie-consent').length) {
		//Allow cookies (default - hides pop-up)
		$('#wpk-cookie-allow-button').on('click', function(){
			document.cookie = "wpk_cookie_consent=allow; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/; SameSite=Strict";
			$('#wpk-cookie-consent').fadeOut();
		});
		//Dismiss cookies
		$('#wpk-cookie-dismiss-button').on('click', function(){
			document.cookie = "wpk_cookie_consent=dismiss; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/; SameSite=Strict";
			$('#wpk-cookie-consent').fadeOut();
		});
		//Deny cookies
		$('#wpk-cookie-deny-button').on('click', function(){
			document.cookie = "wpk_cookie_consent=deny; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/; SameSite=Strict";
			$('#wpk-cookie-consent').fadeOut();
		});
	}
    
}); //End jQuery

